/* eslint-disable simple-import-sort/imports */
import "../../styles/base.scss";
import "./app.scss";
import userAgent from "../../utils/userAgent";

import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";

import Icon from "../../components/interface/Icon";
import IdentifierSlug from "../../components/interface/IdentifierSlug";
import NavigationToolbar from "../../components/navigationToolbar";
import AppPortal from "../../components/portal/AppPortal";
import { asPortalChild } from "../../components/portal/asPortalChild";
import SplitView from "../../components/splitView";
import {
  GLOBAL_FILTER_PANEL,
  ITEM_CARD_NARRATIVE_LIST_VIEW,
  ITEM_CARD_SEQUENCE_LIST_VIEW,
  ITEM_INSPECTOR_PANEL,
  LOCAL_FILTER_PANEL,
  TUTORIAL_PANEL,
  SCROLL_TO_DATE_PANEL,
  SEARCH_PANEL,
  HARVARD_SETTINGS_PANEL,
  SETTINGS_PANEL
} from "../../constants/identifiers";
import PubSubTopics from "../../constants/pubSubTopics";
import Dimensions from "../../constants/styles/dimensions";
import { appStateOperations, appStateSelectors } from "../../modules/appState";
import batchOperations from "../../modules/batchOperations";
import { calendarSelectors } from "../../modules/definition/calendar";
import { typeSelectors } from "../../modules/definition/types";
import { itemOperations } from "../../modules/items";
import { preferencesSelectors } from "../../modules/preferences";
import { uiStateOperations, uiStateSelectors } from "../../modules/uiState";
import { welcomeOperations, welcomeSelectors } from "../../modules/welcome";
import { isNativeCommsInstalled, nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import { immutableRecords, PropTypeShapes } from "../../types";
import { mergeDispatchToProps, wrapEditingComponent } from "../../utils/codeSplit";
import preprocessorQuery from "../../utils/preprocessorQuery";
import EntityTreeView from "../entityList/EntityTreeView";
import ItemCardNarrativeListView from "../ItemCardList/ItemCardNarrativeListView";
import ItemCardSequenceListView from "../ItemCardList/ItemCardSequenceListView";
import getSelectedDisplayItems from "../sharedSelectors/displayItems/getSelectedDisplayItems";
import SmartErrorBoundary from "../smartErrorBoundary";
import SmartScreen from "../smartScreen";
import HarvardWelcomeScreen from "../welcomeScreen/harvard";
import UpgradeWizard from "../welcomeScreen/upgradeWizard";
import { autoUpdatesSelectors } from "../../modules/autoUpdates";
import WorkspaceMobile from "../workspace/workspace.mobile";
import wrapWorkView from "../workView/wrapWorkView";
import Shared from "./App.shared";
import selectors from "./selectors";
//#!if harvard !== true
// import TemplateWizard from "../welcomeScreen/templateWizard";
// import { fileConflictsOperations, fileConflictsSelectors } from "../../modules/fileConflicts";
//#!endif

const isReadonly = preprocessorQuery.isReadonly();

const isIos12 = userAgent.isIos12App();

const onIdentifierClick = itemId => {
  PubSub.publish(PubSubTopics.scrollToItem, { id: itemId });
};

const getMainView = (isDataLoaded, viewMode) => {
  let sequenceViewId = "primaryView";
  let narrativeViewId = "primaryView";
  //#!if harvard === true
  sequenceViewId = ITEM_CARD_SEQUENCE_LIST_VIEW;
  narrativeViewId = ITEM_CARD_NARRATIVE_LIST_VIEW;
  //#!endif

  if (!isDataLoaded) {
    return Shared.createLoadingDiv();
  }

  switch (viewMode) {
    case ITEM_CARD_SEQUENCE_LIST_VIEW: {
      const sequenceViewData = {
        viewId: sequenceViewId,
        label: "All Events",
        isActive: true,
        isFilterActive: false,
        storedSize: immutableRecords.SizeRecord()
      };
      return wrapWorkView(<ItemCardSequenceListView viewId={sequenceViewId} />, sequenceViewData, 0, 0, 1, 1, {});
    }
    case ITEM_CARD_NARRATIVE_LIST_VIEW: {
      const narrativeViewData = {
        viewId: narrativeViewId,
        label: "All Events",
        isActive: true,
        isFilterActive: false,
        storedSize: immutableRecords.SizeRecord()
      };

      return wrapWorkView(<ItemCardNarrativeListView viewId={narrativeViewId} />, narrativeViewData, 0, 0, 1, 1, {});
    }
    case TUTORIAL_PANEL:
      return Shared.createTutorialPanel;
    default:
      return <EntityTreeView key="entityTreeView" typeId={viewMode} />;
  }
};

const createToolbarFooterSplit = mainView => {
  const toolbar = Shared.createToolbar();

  const safeMainView = (
    <SmartErrorBoundary key="mobileWorkspace">
      <WorkspaceMobile key="mobileWorkspace">{mainView}</WorkspaceMobile>
    </SmartErrorBoundary>
  );

  const footer = Shared.createFooter;
  const children = [toolbar, safeMainView, footer];

  return (
    <SplitView key="mainViewSplit" vertical={false} constraints={selectors.getMobileSplitConstraints()}>
      {children}
    </SplitView>
  );
};

const createToolbarSplit = mainView => {
  const toolbar = Shared.createToolbar();
  const children = [toolbar, mainView];

  return (
    <SplitView key="mainViewSplit" vertical={false} constraints={selectors.getHarvardMobileSplitConstraints()}>
      {children}
    </SplitView>
  );
};

const createInspectorSplit = (onBackClick, backText, title, identifierComponent) => {
  const toolbar = (
    <NavigationToolbar
      key="inspectorNavToolbar"
      showBack={true}
      showBackArrow={true}
      backText={backText}
      onBackClick={onBackClick}
      title={title}
      showRightComponent={true}
      rightComponent={identifierComponent}
      flexLeft={1}
      flexCenter={3}
      flexRight={1}
    />
  );
  const inspector = Shared.createItemInspector();
  const children = [toolbar, inspector];

  let constraints = selectors.getToolbarSplitConstraints(false);

  return (
    <SplitView key="inspectorSplit" vertical={false} constraints={constraints}>
      {children}
    </SplitView>
  );
};

class MobilePortraitApp extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.onPulseAnimationEnd = this.onPulseAnimationEnd.bind(this);
    this.onWizardCancel = this.onWizardCancel.bind(this);
    this.onWizardDone = this.onWizardDone.bind(this);
    this.onUpgradeWizardCancel = this.onUpgradeWizardCancel.bind(this);
    this.onUpgradeWizardDone = this.onUpgradeWizardDone.bind(this);
    this.getScrollToIcon = this.getScrollToIcon.bind(this);
    this.onShiftItemsBy = this.onShiftItemsBy.bind(this);
    this.onScrollToDateChange = this.onScrollToDateChange.bind(this);
    this.onScrollToDate = this.onScrollToDate.bind(this);
    this.onCloseReleaseNotesModal = this.onCloseReleaseNotesModal.bind(this);

    this._lastViewMode = null;

    this.state = {
      scrollToDate: null
    };
  }

  componentDidMount() {
    this._pubSubPulseAnimationEndToken = PubSub.subscribe(PubSubTopics.pulseAnimationEnd, this.onPulseAnimationEnd);
    if (isReadonly) {
      document.body.classList.add("readonly");
    }
    if (isIos12) {
      document.body.classList.add("ios12");
    }
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this._pubSubPulseAnimationEndToken);
  }

  onPulseAnimationEnd() {
    this.props.onPulseAnimationEnd();
  }

  onWizardCancel() {
    if (isNativeCommsInstalled()) {
      PubSub.publish(PubSubTopics.sendNativeMessage, {
        msg: nativeCommsBroadcastMessageTypes.FILE_CLOSE_AND_DELETE_IF_EMPTY
      });
    } else {
      this.props.onHideWizardInDebug();
    }
  }

  onWizardDone() {}

  onUpgradeWizardCancel() {
    if (isNativeCommsInstalled()) {
      PubSub.publish(PubSubTopics.sendNativeMessage, {
        msg: nativeCommsBroadcastMessageTypes.FILE_CLOSE_AND_DELETE
      });
    } else {
      this.props.onHideWizardInDebug();
    }
  }

  onUpgradeWizardDone() {
    this.setState({ showUpgradeWizard: false });
    this.props.onHideUpgradeWizard();
  }

  getBackText() {
    const { typesById, leftPanelMode } = this.props;
    if (leftPanelMode === SEARCH_PANEL) {
      return "Search";
    }
    switch (this._lastViewMode) {
      case ITEM_CARD_SEQUENCE_LIST_VIEW:
        return "Items";
      case ITEM_CARD_NARRATIVE_LIST_VIEW:
        return "Narrative";
      default:
        return typeSelectors.getTypeLabel(typesById.get(this._lastViewMode));
    }
  }

  getInspectorTitle() {
    return "Inspector";
  }

  onIdentifierClick(itemId) {
    onIdentifierClick(itemId);
    this.props.closeIosInspectorPanel();
    this.getPanelBackAction()();
  }

  getScrollToIcon() {
    const { typesById, selectedItems } = this.props;
    const item = selectedItems.first();
    const typeId = item.type;
    const type = typesById.get(typeId);

    if (type.canIncludeInNarrative || type.showInSequence) {
      return <Icon icon="sidebarScrollToDate" color="iconMono" onClick={() => this.onIdentifierClick(item.id)} />;
    }
    return null;
  }

  getInspectorIdentifierComponent() {
    const { typesById, selectedItems } = this.props;

    if (selectedItems.size > 0) {
      const firstItem = selectedItems.get(0);
      const isMultiple = selectedItems.size > 1;

      if (isMultiple) {
        return <div className="inspectorSelectedItemCount">{selectedItems.size}</div>;
      }

      const type = typesById.get(firstItem.type);
      return (
        <div className="inspectorScrollToItem">
          {this.getScrollToIcon()}
          {!typeSelectors.isAvatarType(type) ? (
            <IdentifierSlug
              label={firstItem.displayId}
              color={firstItem.color}
              onClick={() => onIdentifierClick(firstItem.id)}
            />
          ) : null}
        </div>
      );
    }
  }

  getPanelBackAction() {
    if (
      this._lastViewMode &&
      this._lastViewMode != ITEM_CARD_SEQUENCE_LIST_VIEW &&
      this._lastViewMode != ITEM_CARD_NARRATIVE_LIST_VIEW &&
      this._lastViewMode != TUTORIAL_PANEL
    ) {
      return () => {
        this.props.switchMobileToEntityList(this._lastViewMode);
      };
    } else {
      return () => {
        this.props.onHidePanel();
      };
    }
  }

  onShiftItemsBy(duration) {
    if (duration) {
      this.props.onShiftItemsBy(this.props.selectedItemIds, duration);
    }
  }

  renderMainPage() {
    const {
      templateModalOpen,
      showUpgradeWizard,
      mobileViewMode,
      sampleModalOpen,
      fileConflictsModalOpen
    } = this.props;
    let primaryView = null;

    // Save the current view mode
    const viewMode = mobileViewMode;
    this._lastViewMode = viewMode;
    const mainView = getMainView(this.props.isDataLoaded, mobileViewMode);
    const isHarvard = preprocessorQuery.isHarvard();
    const isReadonly = preprocessorQuery.isReadonly();

    if (isHarvard) {
      if (templateModalOpen) {
        primaryView = asPortalChild(<HarvardWelcomeScreen />);
      } else {
        primaryView = asPortalChild(createToolbarSplit(mainView));
      }
    } else if (fileConflictsModalOpen) {
      primaryView = Shared.createFileConflictsModal(this.props.onCloseFileConflictsModal);
    } else {
      if (!isReadonly) {
        if (sampleModalOpen) {
          primaryView = Shared.createSampleModal(this.props.onCloseSampleModal);
        } else if (templateModalOpen) {
          primaryView = (
            <SmartErrorBoundary isModal={true} modalTitle={"Template Wizard"} onCloseModal={this.onWizardCancel}>
              <TemplateWizard key="templateWizard" onCloseClick={this.onWizardCancel} onDoneClick={this.onWizardDone} />
            </SmartErrorBoundary>
          );
        } else if (showUpgradeWizard) {
          primaryView = (
            <UpgradeWizard
              key="upgradeWizard"
              onCloseClick={this.onUpgradeWizardCancel}
              onDoneClick={this.onUpgradeWizardDone}
            />
          );
        }
      } else {
        if (sampleModalOpen || templateModalOpen) {
          primaryView = Shared.createSampleModal(this.props.onCloseSampleModal);
        }
      }
      primaryView = primaryView || asPortalChild(createToolbarFooterSplit(mainView));
    }

    return <SmartErrorBoundary key="mobileApp">{primaryView}</SmartErrorBoundary>;
  }

  onScrollToDateChange(date) {
    this.setState({ scrollToDate: date });
  }

  onScrollToDate() {
    if (this.state.scrollToDate) {
      PubSub.publish(PubSubTopics.scrollToDate, this.state.scrollToDate);
      this.onScrollToDateChange(null);
      this.getPanelBackAction()();
    }
  }

  onCloseReleaseNotesModal() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.RELEASE_NOTES_READ
    });
  }

  render() {
    const {
      settingsModalOpen,
      leftPanelMode,
      onHideInspector,
      menuPopoverType,
      calendar,
      onSetMenuPopoverType,
      rightPanelMode,
      showReleaseNotesModal
    } = this.props;

    const isHarvard = preprocessorQuery.isHarvard();
    const isReadonly = preprocessorQuery.isReadonly();

    const appStyle = {
      lineHeight: `${Dimensions.BASE_LINE_HEIGHT}em`
    };

    // If we have a file, then we render our mainPage
    // Otherwise, the TemplateWizard is our main (and only) view at this point.
    const mainPage = this.renderMainPage();

    const panelBackAction = this.getPanelBackAction();

    // Now we build up a list of any other children we need to show
    let screenChildren = [mainPage];
    if (settingsModalOpen) {
      const settingsModal = Shared.createSettingsModal(this.props.onCloseSettingsModal);
      screenChildren.push(settingsModal);
    }
    if (this.props.fileVersionTooLowModalOpen) {
      const fileVersionTooLowModal = Shared.createFileVersionTooLowModal(this.props.onCloseFileVersionTooLowModal);
      screenChildren.push(fileVersionTooLowModal);
    }
    if (showReleaseNotesModal) {
      screenChildren.push(Shared.createReleaseNotesModal(this.onCloseReleaseNotesModal));
    }
    if (leftPanelMode === GLOBAL_FILTER_PANEL || leftPanelMode === LOCAL_FILTER_PANEL) {
      const filterPanel = Shared.createSplitViewWithPanel(Shared.createFilterPanel, panelBackAction, "Filter");
      screenChildren.push(asPortalChild(filterPanel));
    }
    if (leftPanelMode === SEARCH_PANEL) {
      const searchPanel = Shared.createSplitViewWithPanel(Shared.createSearchPanel, panelBackAction, "Search");
      screenChildren.push(asPortalChild(searchPanel));
    }
    if (leftPanelMode === SCROLL_TO_DATE_PANEL) {
      // Here we need the toolbar Done to perform the scrolling
      // Therefore the panel only updates the local state of date only,
      // when toolbar clicking done, it performs scrolling according to the state.
      const toolbar = Shared.createSplitViewToolBar("Scroll To Date", panelBackAction, this.onScrollToDate);
      const scrollToDatePanel = Shared.createScrollToDatePanel(this.onScrollToDateChange);
      const panel = Shared.createSplitViewWithPanelAndToolbar(toolbar, scrollToDatePanel);
      screenChildren.push(asPortalChild(panel));
    }
    if (this.props.leftPanelMode === SETTINGS_PANEL) {
      const settingsPanel = Shared.createSplitViewWithPanel(Shared.createSettingsPanel, panelBackAction, "Settings");
      screenChildren.push(asPortalChild(settingsPanel));
    }
    //#!if harvard === true
    if (this.props.leftPanelMode === HARVARD_SETTINGS_PANEL) {
      const harvardSettingsPanel = Shared.createSplitViewWithPanel(
        Shared.createHarvardSettingsPanel,
        panelBackAction,
        "Settings"
      );
      screenChildren.push(asPortalChild(harvardSettingsPanel));
    }
    //#!endif
    if (!isHarvard && !isReadonly && rightPanelMode === ITEM_INSPECTOR_PANEL) {
      const inspectorView = createInspectorSplit(
        onHideInspector,
        this.getBackText(),
        this.getInspectorTitle(),
        this.getInspectorIdentifierComponent()
      );
      screenChildren.push(asPortalChild(inspectorView));
    }

    if (isReadonly && this.props.inspectorModalOpen) {
      const inspectorModal = Shared.createInspectorModal(this.props.onCloseInspectorModal);
      screenChildren.push(inspectorModal);
    }

    let finalChildren = null;
    finalChildren = Shared.wrapInDragDropContainer(<AppPortal>{screenChildren}</AppPortal>);

    return (
      <div key="mobileApp" className={`aeonApp ios mobile ${this.props.isEditMode ? "editMode" : ""}`} style={appStyle}>
        {Shared.createInlineSvg()}
        <SmartScreen key="screen">{finalChildren}</SmartScreen>
        {menuPopoverType
          ? Shared.createMenuPopover(
            menuPopoverType,
            calendar,
            () => {
              onSetMenuPopoverType(null);
            },
            this.onShiftItemsBy,
            null
          )
          : null}
        {wrapEditingComponent(Shared.createNotificationPanel)}
      </div>
    );
  }
}

MobilePortraitApp.propTypes = {
  isDataLoaded: PropTypes.bool.isRequired,
  templateModalOpen: PropTypes.bool.isRequired,
  settingsModalOpen: PropTypes.bool.isRequired,
  onCloseSettingsModal: PropTypes.func.isRequired,
  showUpgradeWizard: PropTypes.bool.isRequired,
  mobileViewMode: PropTypes.string.isRequired,
  switchViewMode: PropTypes.func.isRequired,
  switchMobileToEntityList: PropTypes.func.isRequired,
  selectedItems: ImmutablePropTypes.list.isRequired,
  selectedItemIds: ImmutablePropTypes.list.isRequired,
  typesById: ImmutablePropTypes.map.isRequired,

  leftPanelMode: PropTypes.string,
  rightPanelMode: PropTypes.string,

  globalFontSize: PropTypes.number.isRequired,
  onHideInspector: PropTypes.func.isRequired,
  onHidePanel: PropTypes.func.isRequired,

  onPulseAnimationEnd: PropTypes.func.isRequired,
  calendar: PropTypeShapes.calendar.isRequired,

  onShiftItemsBy: PropTypes.func.isRequired,
  menuPopoverType: PropTypes.string,
  onSetMenuPopoverType: PropTypes.func.isRequired,

  onHideWizardInDebug: PropTypes.func,
  onHideUpgradeWizard: PropTypes.func.isRequired,
  inspectorModalOpen: PropTypes.bool.isRequired,
  onCloseInspectorModal: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  closeIosInspectorPanel: PropTypes.func,
  showUpdateModal: PropTypes.bool.isRequired,
  fileVersionTooLowModalOpen: PropTypes.bool.isRequired,
  onCloseFileVersionTooLowModal: PropTypes.func.isRequired,
  autoUpdatesData: PropTypes.object,
  sampleModalOpen: PropTypes.bool.isRequired,
  onCloseSampleModal: PropTypes.func.isRequired,
  //#!if harvard !== true
// fileConflictsModalOpen: PropTypes.bool.isRequired,
// showReleaseNotesModal: PropTypes.bool.isRequired,
// onCloseFileConflictsModal: PropTypes.func.isRequired
  //#!endif
};

const mapStateToProps = state => {
  const selectedDisplayItems = getSelectedDisplayItems(state.present);

  return {
    isDataLoaded: state.present.isDataLoaded,

    templateModalOpen: state.present.welcome.isVisible,
    settingsModalOpen: uiStateSelectors.getUiStateSettingsModalOpen(state.present),
    showUpgradeWizard: welcomeSelectors.getShowUpgradeWizard(state.present),
    mobileViewMode: appStateSelectors.getMobilePortraitViewType(state.present),

    leftPanelMode: appStateSelectors.getLeftPanelMode(state.present),
    rightPanelMode: appStateSelectors.getRightPanelMode(state.present),

    menuPopoverType: uiStateSelectors.getMenuPopoverType(state.present),
    globalFontSize: preferencesSelectors.getGlobalFontSize(state.present),
    calendar: calendarSelectors.getCalendar(state.present),
    selectedItems: selectedDisplayItems,
    selectedItemIds: selectedDisplayItems.map(i => i.id),
    typesById: typeSelectors.getTypesById(state.present),
    inspectorModalOpen: uiStateSelectors.getUiStateInspectorModalOpen(state.present),
    isEditMode: uiStateSelectors.getIsEditMode(state.present),
    showUpdateModal: autoUpdatesSelectors.showUpdateModal(state.present),
    fileVersionTooLowModalOpen: uiStateSelectors.getUiStateFileVersionTooLowModalOpen(state.present),
    autoUpdatesData: autoUpdatesSelectors.getAutoUpdatesData(state.present),
    sampleModalOpen: uiStateSelectors.getUiStateSampleModalOpen(state.present),
    //#!if harvard !== true
// fileConflictsModalOpen: fileConflictsSelectors.getShowConflictsModal(state.present),
    //#!endif
    showReleaseNotesModal: autoUpdatesSelectors.showReleaseNotesModal(state.present)
    //#!endif
  };
};

const readonlyActions = {
  onHideInspector: batchOperations.closeMobileInspectorAndClearSelection,
  onHidePanel: batchOperations.hideLeftPanelAndClearSelection,
  switchViewMode: appStateOperations.switchMobilePortraitViewType,
  switchMobileToEntityList: batchOperations.switchMobileToEntityList,
  closeIosInspectorPanel: appStateOperations.closeIosInspectorPanel,
  onSetMenuPopoverType: uiStateOperations.setMenuPopoverType,
  onHideUpgradeWizard: welcomeOperations.hideUpgradeWizard,
  onCloseSettingsModal: uiStateOperations.hideSettingsModal,
  onCloseInspectorModal: uiStateOperations.hideInspectorModal,
  onCloseSampleModal: uiStateOperations.hideSampleModal,
  //#!if harvard !== true
// onCloseFileConflictsModal: fileConflictsOperations.hideConflictsModal,
  //#!endif
  onCloseFileVersionTooLowModal: uiStateOperations.hideFileVersionTooLowModal
};

const editingActions = {
  onPulseAnimationEnd: uiStateOperations.pulsateIcon,
  onHideWizardInDebug: welcomeOperations.hideWelcome,
  onShiftItemsBy: (selectedItemIds, duration) => {
    if (duration) {
      return itemOperations.moveByTimespan(selectedItemIds.toArray(), duration.toObject());
    }
  }
};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, editingActions, dispatch);

const connectedApp = connect(mapStateToProps, mapDispatchToProps)(MobilePortraitApp);

export default connectedApp;
